import { Guid } from "guid-typescript";

export class Package {
	PackageID: Guid; 
	Content: any;
} 
